/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IGisDatastoreScope extends angular.IScope {
        model: models.GisDatastoreModel;
    }

    export class GisDatastoreController implements IController {
        scope: IGisDatastoreScope;

        constructor($scope: IGisDatastoreScope,
            gisDatastoreService: services.GisDatastoreService,
            growl: angular.growl.IGrowlService,
            systemLevelService:services.SystemLevelService) {
            $scope.model = new models.GisDatastoreModel(gisDatastoreService, growl,systemLevelService);
        }
    }
}

warsApp.registerController('GisDatastoreController', ['$scope', 'gisDatastoreService', 'growl','systemLevelService']);